import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-distributors',
    templateUrl: './distributors.component.html',
    styleUrls: ['./distributors.component.css'],
    imports: [RouterModule]
})
export class DistributorsComponent {
  ngOnInit() {}
}
